import type { Validation } from '@wix/ambassador-forms-v4-form/types';

import { type ValidationError } from '../submission-validation/errors';

export interface DeriveErrorOptions {
  value?: string;
}

export enum DateFieldErrorSuffix {
  YEAR_MONTH = 'year-month',
  YEAR_DAY = 'year-day',
  MONTH_DAY = 'month-day',
  YEAR = 'year',
  MONTH = 'month',
  DAY = 'day',
}

export enum DateTimeFieldErrorSuffix {
  YEAR_MONTH_TIME = 'year-month-time',
  YEAR_DAY_TIME = 'year-day-time',
  MONTH_DAY_TIME = 'month-day-time',
  YEAR_TIME = 'year-time',
  MONTH_TIME = 'month-time',
  DAY_TIME = 'day-time',
  TIME = 'time',
}

export interface DateFieldValidationError
  extends Omit<ValidationError, 'params'> {
  params: {
    suffix: DateFieldErrorSuffix;
  };
}

export interface DateTimeFieldValidationError
  extends Omit<ValidationError, 'params'> {
  params: {
    suffix: DateTimeFieldErrorSuffix | DateFieldErrorSuffix;
  };
}

export function isDateFieldValidationError(
  error?: ValidationError | DateFieldValidationError,
): error is DateFieldValidationError {
  return (
    error?.params !== undefined &&
    'suffix' in error.params &&
    Object.values(DateFieldErrorSuffix).includes(
      error.params.suffix as DateFieldErrorSuffix,
    )
  );
}

export function isDateTimeFieldValidationError(
  error?: ValidationError | DateTimeFieldValidationError,
): error is DateTimeFieldValidationError {
  return (
    error?.params !== undefined &&
    'suffix' in error.params &&
    (Object.values(DateTimeFieldErrorSuffix).includes(
      error.params.suffix as DateTimeFieldErrorSuffix,
    ) ||
      Object.values(DateFieldErrorSuffix).includes(
        error.params.suffix as DateFieldErrorSuffix,
      ))
  );
}

export type { Validation, ValidationError };
